import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get, sample } from 'lodash';
import numeral from 'numeral';
import { SanitizeHtml } from '@bd/bdcore-utilities';
// import VideoPlayer from '@bd/bdui-videoplayer';
import CarouselDetailPages from '../../components/CarouselDetailPages';

const styles = css`
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function DetailHeader({ home, metro }) {
  const carouselSlides = [
    ...get(home, 'photos', []),
    ...get(home, 'elevationPhotos', []),
  ];
  const sampleImage = sample(get(home, 'photos'));

  if (get(home, 'tourUrl')) {
    carouselSlides.splice(1, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={get(home, 'tourUrl')} /></div>),
    });
  }

  if (get(home, 'video')) {
    carouselSlides.splice(1, 0, {
      type: 'video',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`} dangerouslySetInnerHTML={SanitizeHtml(get(home, 'video'))} />),
      thumb: get(sampleImage, 'contentUrl'),
    });
  }
  return (
    <div className={styles}>
      <div className="DetailHeader">
        <div className="container">
          <CarouselDetailPages
            items={carouselSlides}
            thumbnails
            mainImageProps={{
              width: 2000,
              height: 1125,
              exact: true,
            }}
            thumbnailImageProps={{
              width: 475,
              height: 267,
              exact: true,
            }}
            carouselTitle={get(home, 'address.streetAddress')}
            carouselSubtitle={`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')} ${get(home, 'address.postalCode')}`}
            carouselList={
              <ul className="Carousel_list">
                {
                  get(home, 'price') > 0 &&
                  <li className="Carousel_listItem">
                    <span className="Carousel_listItemValue">${numeral(get(home, 'price')).format('0,0')}</span>
                  </li>
                }
                {
                  get(home, 'beds') > 0 &&
                  <li className="Carousel_listItem">
                    <span className="Carousel_listItemValue">{get(home, 'beds')}</span>
                    <span className="Carousel_listItemLabel">Beds</span>
                  </li>
                }
                {
                  get(home, 'bathsFull') > 0 &&
                  <li className="Carousel_listItem">
                    <span className="Carousel_listItemValue">{get(home, 'bathsFull')}</span>
                    <span className="Carousel_listItemLabel">Full Baths</span>
                  </li>
                }
                {
                  get(home, 'bathsHalf') > 0 &&
                  <li className="Carousel_listItem">
                    <span className="Carousel_listItemValue">{get(home, 'bathsHalf')}</span>
                    <span className="Carousel_listItemLabel">Half Baths</span>
                  </li>
                }
                {
                  get(home, 'sqft') > 0 &&
                  <li className="Carousel_listItem">
                    <span className="Carousel_listItemValue">{numeral(get(home, 'sqft')).format('0,0')}</span>
                    <span className="Carousel_listItemLabel">Sq Ft</span>
                  </li>
                }
              </ul>
            }
            metro={get(metro, 'name')}
          />
        </div>
      </div>
    </div>
  );
}

DetailHeader.propTypes = {
  home: PropTypes.object.isRequired,
  metro: PropTypes.object.isRequired,
};

export default DetailHeader;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/DetailHeader.js